import React from "react"
import Container from "../Container"
import { Props } from "./props"

const Term: React.FC<Props> = (props) => (
  <Container contentType="terms" {...props} />
)
export default Term
